(function(angular, schoolwork12) {
'use strict';
angular.module(schoolwork12.app.graduationPlan.name)
    .factory('graduationPlanSvc', ['$http', '$q', function ($http, $q) {

            var getAllGraduationPlans = function (keycode, schoolId) {
                console.info('In getAllGraduationPlans service');
                console.info('Making a call to service');
                var allgraduationPlans = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.getSchoolDiplomaEndpoint + schoolId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    allgraduationPlans = response.data;
                    deferred.resolve(allgraduationPlans);
                    console.info('Got the graduation plans');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getSubjectsBySchool = function (keycode, schoolId, courseFlag) {
                console.info('In getSubjectsBySchool service');
                console.info('Making a call to service');
                var subjects = null;
                var deferred = $q.defer();
                var request = $http({
                    cache:true,
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.getSchoolSubjectsEndpoint + schoolId + '?courses=' + courseFlag,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    subjects = response.data;
                    deferred.resolve(subjects);
                    console.info('Got the subjects');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };


            var saveSchoolDiploma = function (keycode, schoolId, data) {
                console.info('In saveSchoolDiploma service');
                console.info('Making a call to service');
                var result = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.graduationPlan.endpoints.saveSchoolDiplomaEndpoint+schoolId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data : data
                });
                request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Save the diploma');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var saveGradPlan = function (keycode, diplomaId, data) {
                console.info('In saveGradPlan service');
                console.info('Making a call to service');
                var result = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.graduationPlan.endpoints.getGraduationPlanEndpoint+diplomaId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data : data
                });
                request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Save the gradPlan');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getDiplomaById = function (keycode, diplomaId) {
                console.info('In getDiplomaById service');
                console.info('Making a call to service');
                var diploma = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.getDiplomaById + diplomaId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    diploma = response.data;
                    deferred.resolve(diploma);
                    console.info('Got the diploma by school');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };
            
            var getSchoolTerms = function(keycode){
                console.info('Making a call to getSchoolTerms service');
                var schoolTerms = null;
                var deferred = $q.defer();
                var request = $http({
                    cache:true,
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.getSchoolTerms,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    schoolTerms = response.data;
                    deferred.resolve(schoolTerms);
                    console.info('Get school terms');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            }; 
           
            var editSchoolDiploma = function(keycode, data, diplomaId){
                console.info('Making a call to editSchoolDiploma service');
                var result = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'PUT',
                    url: schoolwork12.app.graduationPlan.endpoints.editSchoolDiplomaEndpoint+diplomaId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data : data
                });
                request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Edit the diploma');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };  
            
            var getGradPlanById = function(keycode, diplomaId){
                console.info('In getGradPlan service');
                console.info('Making a call to service');
                var gradPlan = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.getGraduationPlanEndpoint + diplomaId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    gradPlan = response.data;
                    deferred.resolve(gradPlan);
                    console.info('Got the diploma by school');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            }; 
            
            var editGradPlanTerms = function(keycode, data, diplomaId){
                console.info('In editGradPlanTerms service');
                console.info('Making a call to service');
                var result = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'PUT',
                    url: schoolwork12.app.graduationPlan.endpoints.editGradPlanEndpoint + diplomaId + '/terms',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: data
                });
                request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Edit the GradPlan Terms');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };
            
            var editGradPlanYears = function(keycode, data, diplomaId){
                console.info('In editGradPlanPlans service');
                console.info('Making a call to service');
                var result = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'PUT',
                    url: schoolwork12.app.graduationPlan.endpoints.editGradPlanEndpoint + diplomaId + '/years',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: data
                });
                request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Edit the GradPlan Years');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getAddRequirementCategories = function (keycode) {
                console.info('In getAddRequirementCategories service');
                console.info('Making a call to service');
                var categories = null;
                var deferred = $q.defer();
                var request = $http({
                    cache:true,
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.getCategoriesEndpoint,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    categories = response.data;
                    deferred.resolve(categories);
                    console.info('Got the additional requirements categories');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

             var getEditRequirementCategories = function (keycode, gradPlanId) {
                console.info('In getEditRequirementCategories service');
                console.info('Making a call to service');
                var categories = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.editGradPlanEndpoint + gradPlanId + '/addreq',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    categories = response.data;
                    deferred.resolve(categories);
                    console.info('Got the additional requirements categories');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };
        
            var saveAddRequirement = function (keycode, gradPlanId, data) {
                console.info('In saveAddRequirement service');
                console.info('Making a call to service');
                var result = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.graduationPlan.endpoints.editGradPlanEndpoint+gradPlanId+'/addreq',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data : data
                });
                request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Save the additional requirement');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };
        
            var editAddRequirement = function(keycode, gradPlanId, data){
                console.info('In editAddRequirement service');
                console.info('Making a call to service');
                var result = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'PUT',
                    url: schoolwork12.app.graduationPlan.endpoints.editGradPlanEndpoint+gradPlanId+'/addreq',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data: data
                });
                request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Edit the additional requirement');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var saveGradPlanNotes = function (keycode, studentGradPlanId, data) {
                console.info('In saveGradPlanNotes service');
                console.info('Making a call to service');
                var result = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'POST',
                    url: schoolwork12.app.graduationPlan.endpoints.saveGradPlanNotesEndpoint + studentGradPlanId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    },
                    data : data
                });
                request.then(function (response) {
                    result = response.data;
                    deferred.resolve(result);
                    console.info('Save the gradPlanNotes');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getSavedNotes = function (keycode, studentGradPlanId) {
                console.info('In getSavedNotes service');
                console.info('Making a call to service');
                var allsavedNotes = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.saveGradPlanNotesEndpoint + studentGradPlanId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    allsavedNotes = response.data;
                    deferred.resolve(allsavedNotes);
                    console.info('Got the saved notes');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

             var getAuditTrailSavedNotes = function (keycode, studentGradPlanId) {
                console.info('In getSavedNotes service');
                console.info('Making a call to service');
                var allsavedNotes = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.getAuditTrailGradPlanNotesEndpoint + studentGradPlanId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    allsavedNotes = response.data;
                    deferred.resolve(allsavedNotes);
                    console.info('Got the saved notes');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getLCStudentsList = function (keycode, personId, schoolId) {
                console.info('In getLCStudentsList service');
                console.info('Making a call to service');
                var stuList = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.graduationPlan.endpoints.getLearningCoachEndpoint + personId + '/school/' + schoolId,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    stuList = response.data;
                    deferred.resolve(stuList);
                    console.info('Got the list of students for LC');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };
        
            var editSubjectView = false;
            var subjectFields = [];
            var mapK12SubjectIds = [];
            var mapSchoolSubjectIds = [];
            var date;
            return {
                getAllGraduationPlans: getAllGraduationPlans,
                getSubjectsBySchool: getSubjectsBySchool,
                getDiplomaById: getDiplomaById,
                saveSchoolDiploma: saveSchoolDiploma,
                getSchoolTerms: getSchoolTerms,
                editSchoolDiploma: editSchoolDiploma,
                getGradPlanById: getGradPlanById,
                saveGradPlan: saveGradPlan,
                editGradPlanTerms: editGradPlanTerms,
                editGradPlanYears: editGradPlanYears,
                getAddRequirementCategories: getAddRequirementCategories,
                saveAddRequirement: saveAddRequirement,
                getEditRequirementCategories: getEditRequirementCategories,
                editAddRequirement: editAddRequirement,
                editSubjectView: editSubjectView,
                subjectFields : subjectFields,
                mapK12SubjectIds : mapK12SubjectIds,
                mapSchoolSubjectIds : mapSchoolSubjectIds,
                date : date,
                saveGradPlanNotes: saveGradPlanNotes,
                getSavedNotes: getSavedNotes,
                getAuditTrailSavedNotes: getAuditTrailSavedNotes,
                getLCStudentsList: getLCStudentsList
            };
        }

    ]);
}(angular, schoolwork12));